import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { Box, Button, Collapse, Flex, Heading, IconButton, Input, Spacer, useDisclosure } from "@chakra-ui/react";
import { ChangeEvent, ChangeEventHandler, useState } from "react";
import { colors } from "../../Theme";

const Billing = (props: { print: () => void; saveScreenshot: () => void }) => {
  const [items, setItems] = useState([
    {
      skey: "stella",
      price: 0,
      name: "Памятник",
    },
    {
      skey: "graver",
      price: 0,
      name: "Гравировка",
    },
    {
      skey: "base",
      price: 0,
      name: "Подставка",
    },
    {
      skey: "flowers",
      price: 0,
      name: "Цветник",
    },
    {
      skey: "plate",
      price: 0,
      name: "Надгробная плита",
    },
    {
      skey: "accessories",
      price: 0,
      name: "Аксессуары",
    },
    {
      skey: "plinth",
      price: 0,
      name: "Цоколь",
    },
    {
      skey: "fence",
      price: 0,
      name: "Ограда",
    },
    {
      skey: "beauty",
      price: 0,
      name: "Благоустройство",
    },
    {
      skey: "delivery",
      price: 0,
      name: "Доставка",
    },
    {
      skey: "installation",
      price: 0,
      name: "Установка",
    },
  ]);
  const [ total, setTotal ] = useState(0);
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: false });

  const handleChange = (ev: ChangeEvent) => {
    const target = ev.target as HTMLInputElement;
    if (!target) return;
    const name = target.name;
    let price = parseFloat(target.value.replace(",", "."));
    if (isNaN(price)) return;
    console.log(name, price);
    let tmpItems = [...items];
    let total = 0;
    for (var i = 0; i < tmpItems.length; i++) {
      let item = tmpItems[i];
      if (item.skey === name) {
        item.price = price;
      }
      total += item.price;
    }
    setItems(tmpItems);
    setTotal(total);
  }

  return (
    <Box position="relative" w="100%">
      <Heading
        size="md"
        variant="editor"
        textAlign="center"
        cursor="pointer"
        onClick={onToggle
        }
      >
        Рассчет сметы
      </Heading>
      <IconButton
        pos="absolute"
        top={".5rem"}
        right={".5rem"}
        icon={
          isOpen ? (
            <ChevronUpIcon boxSize={"3rem"} />
          ) : (
            <ChevronDownIcon boxSize={"3rem"} />
          )
        }
        aria-label={isOpen ? "Свернуть" : "Раскрыть"}
        onClick={onToggle}
      />
      <Collapse in={isOpen} animateOpacity>
        <Flex direction="column" p={5} overflowY="auto">
          {items.map((item: any) => (
            <BillingSection
              onChange={handleChange}
              key={item.skey}
              {...item}
            />
          ))}

          <Collapse in={total > 0} animateOpacity>
            <Flex justify="space-between">
              <Box>ИТОГО</Box>
              <Box>{total} р.</Box>
            </Flex>
          </Collapse>

          <Flex align="center" justify="space-between">
            <Button onClick={props.print}>Печать</Button>
            <Button onClick={props.saveScreenshot}>Скриншот</Button>
          </Flex>
        </Flex>
      </Collapse>
    </Box>
  );
};


const BillingSection = (props: {
    skey: string;
    name: string;
    price: number;
    onChange: ChangeEventHandler;
    onDelete: Function;
  }) => {
    return (
      <Flex align="center" mb="1rem">
        <div className="Header">{props.name}</div>
        <Spacer />
        <Input
          borderColor={colors.brown}
          size="sm"
          type="text"
          onChange={props.onChange}
          name={props.skey}
          value={props.price}
          maxW={"10rem"}
          textAlign="right"
        />
      </Flex>
    );
  }
  

export default Billing;
